import VisualizationBaseLayout from "./visualizationBaseLayout";

export default VisualizationBaseLayout;